import DataRequest from '@get-bridge/learn-legacy-shared/dist/core/DataRequest'
import NotificationSchema from '../schemas/NotificationSchema'

export default DataRequest({
  schema: NotificationSchema,
  url: `/api/learner/notifications/%@`,
  type: 'DELETE',
})



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/notifications/data_requests/deleteNotification.js